import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
`;


export const InfoContainer = styled("div")`
  text-align: right;
  margin-top:15px;
`;

export const InfoText = styled("p")`
  font-size:14px;
  margin-right:5px;
  direction:rtl;
  text-align:right;
  width:100%;
  margin-bottom:5px;
`;

export const InfoTextRed = styled("p")`
  display:inline;
  font-size:15px;
  margin-right:2px;
  margin-left:2px;
  direction:rtl;
  text-align:right;
  width:100%;
  margin-bottom:5px;
  color:red;
`;


export const PaymentGatewayContainer = styled("div")`
  /* text-align: right; */
  margin-top:25px;
  margin-bottom:25px;
  cursor:pointer;
  display:flex;
  flex-direction:row;
  text-align: center;
  justify-content: center;
  align-items: center;
  width:100%;
`;

export const PaymentGatewayText = styled("p")`
  font-size:14px;
  padding:15px;
  text-align:right;
  display:inline;
`;

export const ImageWarningContainer = styled("div")`
  display:flex;
  flex-direction:row;
  text-align: center;
  justify-content: center;
  align-items: center;
  width:100%
`;


export const BankGateWayLogo = styled("img")`
  height:100px;
  width:100px;
  padding:15px;
`;